<template>
  <v-layout column>
    <v-layout
      v-show="group[0].expanded"
      class="mt-2"
    >
      <v-btn
        small
        @click="expanded = !expanded"
      >
        {{ expanded ? "Скрыть доп. поля" : "Показать доп. поля" }}
      </v-btn>
    </v-layout>
    <v-layout wrap>
      <v-flex
        v-for="element in group"
        v-show="!element.control.hide && (!element.expanded || expanded)"
        :key="element.name"
        :xs12="
          element.control.width
            ? element.control.width === 12
            : group.length === 1
        "
        :xs10="
          element.control.width
            ? element.control.width === 10
            : group.length === 1
        "
        :xs6="
          element.control.width
            ? element.control.width === 6
            : group.length === 2
        "
        :xs4="
          element.control.width
            ? element.control.width === 4
            : group.length === 3
        "
        :xs3="
          element.control.width
            ? element.control.width === 3
            : group.length === 4
        "
        :xs2="
          element.control.width
            ? element.control.width === 2
            : group.length === 6
        "
      >
        <TitleTextField
          v-if="element.control.type === 'title-text'"
          v-model="entity[element.name]"
          :required="element.control.required"
          :rules="element.control.rules"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :tooltip="element.control.tooltip ? element.control.tooltip : ''"
          :disabled="element.disabled"
          class="mx-2 mb-3"
          @input="entityChange"
        />

        <v-text-field
          v-if="
            ['text', 'phone', 'isoCodeAlpha3', 'prefix'].indexOf(
              element.control.type
            ) != -1
          "
          :ref="element.control.type"
          v-model="entity[element.name]"
          class="mx-2 mb-3"
          :required="element.control.required"
          :rules="element.control.rules"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :mask="getMask(element.control.type)"
          hide-details
          autofocus
          outline
          height="44"
          @input="entityChange()"
        />

        <v-text-field
          v-if="['email'].indexOf(element.control.type) != -1"
          v-model="entity[element.name]"
          v-validate="'email'"
          class="mx-2 mb-3"
          :required="element.control.required"
          :rules="element.control.rules"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          hide-details
          :error-messages="errors.collect('entity[element.name]')"
          data-vv-name="entity[element.name]"
          outline
          height="44"
          @input="entityEmailChange(element.name)"
        />

        <DecimalEditor
          v-if="element.control.type === 'number'"
          v-model="entity[element.name]"
          class="mx-2 mb-3"
          :required="element.control.required"
          :rules="element.control.rules"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :scale="2"
          :outline="true"
          :height-field="44"
          :disabled="element.disabled"
          @input="entityChange"
        />

        <app-reference
          v-if="element.control.type === 'reference'"
          v-model="entity[element.name]"
          class="mx-2 mb-3"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :rules="element.control.rules"
          :resource="element.control.resource"
          :without-parent-lock="element.control.withoutParentLock"
          :parent-filter="
            element.control.parentFilter ? element.control.parentFilter : null
          "
          :parent-id="
            element.control.parentField
              ? entity[element.control.parentField]
                ? entity[element.control.parentField].id
                : 0
              : null
          "
          :data-restored="entityRestored"
          :component-name="element.control.component"
          :outline="true"
          :height-field="44"
          :disabled="element.control.disabled"
          :scroll-value="scrollValue"
          @input="entityChange($event, element)"
        />

        <app-tiny-reference
          v-if="element.control.type === 'tiny-reference'"
          v-model="entity[element.name]"
          class="mx-2 mb-3"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :resource="element.control.resource"
          :rules="element.control.rules"
          :parent-filter="
            element.control.parentFilter ? element.control.parentFilter : null
          "
          :parent-id="
            element.control.parentField
              ? entity[element.control.parentField]
                ? entity[element.control.parentField].id
                : 0
              : null
          "
          :outline="true"
          :height-field="44"
          :scroll-value="scrollValue"
          @input="entityChange"
        />

        <MultipleReferenceCompact
          v-if="element.control.type === 'multiple-reference'"
          v-model="entity[element.name]"
          class="mx-2 mb-3"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :rules="element.control.rules"
          :resource="element.control.resource"
          :component-name="element.control.component"
          :disable-add="false"
          :outline="true"
          :height-field="44"
          @input="entityChange"
        />

        <EnumSelect
          v-if="element.control.type === 'enum'"
          v-model="entity[element.name]"
          class="mx-2 mb-3"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :resource="element.control.resource"
          :rules="element.control.rules"
          :parent-filter="
            element.control.parentFilter ? element.control.parentFilter : null
          "
          :parent-id="
            element.control.parentField
              ? entity[element.control.parentField]
                ? entity[element.control.parentField].id
                : 0
              : null
          "
          :outline="true"
          :height-field="44"
          :scroll-value="scrollValue"
          :return-object="element.control.ojectType"
          :clearable="element.control.clearable"
          @input="entityChange"
        />

        <app-reference-list
          v-if="element.control.type === 'reference-list'"
          v-model="entity[element.name]"
          class="mx-2 mb-3"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :properies-map="element.control.properiesMap"
          :columns="element.control.columns"
          :search-placeholder="element.control.searchPlaceholder"
          :resource="element.control.resource"
          :search-field="element.control.searchField"
          :reference-component="element.control.component"
          :data-test="element.control.dataTest"
          @change="entityChange"
        />

        <app-date-picker
          v-if="element.control.type === 'date'"
          v-model="entity[element.name]"
          class="mx-2 mb-3"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :readonly="
            element.control.readonly ? false : element.control.readonly
          "
          :margin-class="
            element.control.marginClass ? element.control.marginClass : ''
          "
          :without-initial-data="element.control.withoutInitialData"
          :outline="true"
          :height-field="44"
          :scroll-value="scrollValue"
          @input="entityChange"
        />

        <app-tiny-reference
          v-if="element.control.type === 'bool'"
          v-model="entity[element.name]"
          class="mx-2 mb-3"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :custom-items="[
            { value: true, text: element.control.trueValue },
            { value: false, text: element.control.falseValue }
          ]"
          :without-selected="element.control.withoutSelected"
          :rules="element.control.rules"
          :outline="true"
          :height-field="44"
          :scroll-value="scrollValue"
          @input="entityChange"
        />

        <app-tiny-reference
          v-if="element.control.type === 'tiny-reference_by-string-list'"
          v-model="entity[element.name]"
          class="mx-2 mb-3"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :without-selected="element.control.withoutSelected"
          :rules="element.control.rules"
          :resource="element.control.resource"
          :parent-filter="
            element.control.parentFilter ? element.control.parentFilter : null
          "
          :parent-id="
            element.control.parentField
              ? entity[element.control.parentField]
                ? entity[element.control.parentField].id
                : 0
              : null
          "
          :outline="true"
          :height-field="44"
          :scroll-value="scrollValue"
          @input="entityChange"
        />

        <Label
          v-if="element.control.type === 'label'"
          class="mx-2 mb-3"
          :title="element.title"
          :items="element.control.lables"
          @input="entityChange"
        />
        <app-switch
          v-if="element.control.type === 'bool-switch'"
          v-model="entity[element.name]"
          :label="
            element.control.required ? element.title + '*' : element.title
          "
          :disabled="element.control.disabled"
          :tooltip="element.control.tooltip ? element.control.tooltip : ''"
          @input="entityChange"
        />

        <EditableStringList
          v-if="element.control.type === 'editable-string-list'"
          v-model="entity[element.name]"
          :title="element.title"
          :mask="getMask(element.control.mask)"
          :rules="element.control.rules"
          :data-test="element.control.dataTest"
          :client-items-per-view="element.control.itemsPerView"
          @input="entityChange"
        />

        <ManagerSelect
          v-if="element.control.type === 'manager-select'"
          v-model="entity[element.name]"
          :label="element.title"
          :rules="element.control.rules"
          :scroll-value="scrollValue"
          class="mx-2"
          @input="entityChange($event, element)"
        />

        <Packages
          v-if="element.control.type === 'packages'"
          v-model="entity[element.name]"
          class="mb-2"
          @change="entityChange($event, element)"
        />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import Label from "../label/Label.vue";
import Packages from "../../views/shippings/components/new-shipping/Packages.vue";

export default {
  components: {
    Label,
    Packages,
  },
  props: [
    "group",
    "entity",
    "entityRestored",
    "outline",
    "isNewEntity",
    "scrollValue",
    "clientItemsPerView",
  ],
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    getMask(controlType) {
      switch (controlType) {
        case "phone":
          return "+##(###)###-##-## *#####";
        case "number":
          return "##########";
        case "isoCodeAlpha3":
          return "AAA";
        case "prefix":
          return "AAA";
        default:
          return "";
      }
    },
    entityChange(selected, element) {
      this.$emit("entity-change", { selected, element });
    },
    entityEmailChange(selected, element) {
      this.$emit("entity-change", { selected, element });
    },
    // entityEmailChange(fieldName, selected, element) {
    //   const mask = this.$options.filters.emailMask(this.entity[fieldName]);
    //   if (mask.changeIndex) {
    //     this.$refs.email[0].setCaretPosition(mask.value.length - 1);
    //   }
    //   this.entity[fieldName] = mask.value;

    //   this.$emit("entity-change", { selected: selected, element: element });
    // }
  },
};
</script>
